import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HomePage } from '../pages/HomePage';
import '../styles.css';

const container = document.getElementById('app')!;
createRoot(container).render(
  <StrictMode>
    <HomePage />
  </StrictMode>,
);
